import React from 'react'
import { FaTimes } from "react-icons/fa";
import "../../Pages/Css/mapCenterStyles.css";
import { formattedGlobalDate } from '../../utils/formattedDates';

const InfoWindowContent = ({
    contrato,
    openModalGaleria,
    openModalContratoSeguimiento,
    openReporteConsolidado,
    openModalSeguir,
    openModalEnVivo,
    onClose,
}) => {
    const estadoEquipo = contrato.Locked ? "Cerrado" : "Abierto";
    const velocidad = `${contrato.Speed || "0"} Km/h`;
    const bateria = contrato.bateria ? `${contrato.bateria}%` : "-";

    const summaryItems = [
        { label: "Estado", value: contrato.TipoReporte || "-" },
        { label: "Bateria", value: bateria },
        { label: "Velocidad", value: velocidad },
    ];

    const deviceRows = [
        { label: "Dispositivo", value: contrato.FKLokDeviceID || "-" },
        { label: "Estado del equipo", value: estadoEquipo },
        { label: "Ult. reporte", value: formattedGlobalDate(contrato.LoksysServerTime) || "-" },
        { label: "Ult. ubicacion", value: contrato.LastReportUbica || "-" },
    ];

    const contractRows = [
        { label: "Container", value: contrato.ContainerNum || "-" },
        { label: "Placa", value: contrato.PlacaTruck || "-" },
        { label: "Empresa", value: contrato.NombreEmpresa || "-" },
        { label: "Transportadora", value: contrato.NombreTranspo || "-" },
        { label: "Ruta", value: contrato.DescripcionRuta || "-" },
    ];

    const driverRows = [
        { label: "Conductor", value: contrato.NombreConductor || "-" },
        { label: "Celular", value: contrato.MovilConductor || "-" },
    ];

    const renderRows = (rows) => rows.map((item) => (
        <div className="info-row" key={item.label}>
            <span className="info-label">{item.label}</span>
            <span className="info-value">{item.value}</span>
        </div>
    ));

    return (
        <div className="info-window-card">
            <div className="info-window-topbar">
                <div className="info-window-topbar-copy">
                    <span className="info-window-kicker">Monitoreo en tiempo real</span>
                    <strong>{contrato.PlacaTruck || contrato.ContainerNum || "Detalle del dispositivo"}</strong>
                </div>
                <button
                    type="button"
                    className="info-window-close-btn"
                    onClick={onClose}
                    aria-label="Cerrar detalle"
                >
                    <FaTimes size={16} />
                </button>
            </div>

            <div className="info-window-content">
                <div className="info-window-summary">
                    {summaryItems.map((item) => (
                        <div className="info-window-summary__chip" key={item.label}>
                            <span className="info-window-summary__label">{item.label}</span>
                            <strong>{item.value}</strong>
                        </div>
                    ))}
                </div>

                <section className="info-window-section info-window-section--device">
                    <div className="info-window-header">Informacion del dispositivo</div>
                    <div className="info-window-body">
                        {renderRows(deviceRows)}
                    </div>
                </section>

                <section className="info-window-section info-window-section--contract">
                    <div className="info-window-header">Informacion del contrato</div>
                    <div className="info-window-body">
                        {renderRows(contractRows)}
                    </div>
                </section>

                <section className="info-window-section info-window-section--driver">
                    <div className="info-window-header">Informacion del conductor</div>
                    <div className="info-window-body">
                        {renderRows(driverRows)}
                    </div>
                </section>

                <div className="info-window-actions mt-2">
                    <button className="btn btn-sm info-window-action-btn info-window-action-btn--primary" onClick={() => openModalContratoSeguimiento(contrato)}>Recorrido</button>
                    <button className="btn btn-sm info-window-action-btn info-window-action-btn--neutral" onClick={() => openModalGaleria(contrato)}>Fotos</button>
                    <button className="btn btn-sm info-window-action-btn info-window-action-btn--info" onClick={() => openModalSeguir(contrato)}>Seguir</button>
                    <button className="btn btn-sm info-window-action-btn info-window-action-btn--danger info-window-live-btn" onClick={() => openModalEnVivo(contrato)}>
                        <span className="info-window-live-dot" aria-hidden="true"></span>
                        En vivo
                    </button>
                    <button className="btn btn-sm info-window-action-btn info-window-action-btn--success" onClick={() => openReporteConsolidado(contrato)}>Reporte</button>
                </div>
            </div>
        </div>
    )
}

export default InfoWindowContent
